// extracted by mini-css-extract-plugin
export default {"stickyHeader":"infinite-table_stickyHeader__kWIX7"};